<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import { Button, ButtonV2, Container, Modal, Text } from '@Shelly/shelly-design-system';
	import { mobile } from 'src/services/mobile-rework';
	import { markHomesWhatsNewSeen } from 'src/helpers/homes-onboarding-helper';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { modalStore } from 'src/stores/ui/modal_states';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { markWhatsNewSeenOnDevice } from 'src/helpers/whats_new_helpers';
	import HomesOnboardingWizard from './HomesOnboardingWizard.svelte';

	const WHATS_NEW_MODAL_ID = 'whatsNewState';

	export let showModal = false;
	export let priority: number;

	const dispatch = createEventDispatcher();

	let showOnboarding = false;

	const dismissStackedWhatsNew = () => {
		const seenTimestamp = Math.floor(Date.now() / 1000);
		modalStore.hideModal(WHATS_NEW_MODAL_ID);
		save_profile('whatsNew', seenTimestamp);
		markWhatsNewSeenOnDevice(seenTimestamp);
	};

	const dismissWhatsNew = async (e?: CustomEvent | MouseEvent) => {
		if (e) e.preventDefault();
		await markHomesWhatsNewSeen();
		showModal = false;
		dispatch('close');
	};

	const openOnboarding = async (e: MouseEvent) => {
		e.preventDefault();
		dismissStackedWhatsNew();
		await markHomesWhatsNewSeen();
		showModal = false;
		showOnboarding = true;
	};

	function handleOnboardingDismiss(): void {
		showOnboarding = false;
		dispatch('close');
	}

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', dismissWhatsNew);
			return () => mobile.removeEventListener('back_button', dismissWhatsNew);
		}
	});
</script>

<Modal {showModal} on:close={dismissWhatsNew} zIndex={priority} hideTitle>
	<Container slot="content" padding="0">
		<div class="d-flex align-items-center flex-direction-column">
			<img src="./images/homes_illustration.svg" alt="" />
			<Text class="mb-s text-center" element="h1">
				{$format('title_homes_whats_new', {
					default: 'Multiple Homes & Home Sharing',
				})}
			</Text>
			<Text class="text-center text-color-muted">
				{$format('description_homes_whats_new', {
					default:
						'Learn more about the Multiple Homes & Home Sharing functionality, manage several locations, bring secondary accounts together, and invite others with the right access level.',
				})}
			</Text>
		</div>
	</Container>

	<div class="d-flex justify-content-end" slot="footer">
		{#if $showNewLayout}
			<ButtonV2
				on:click={dismissWhatsNew}
				variant="secondary"
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{ sm: 'm' }}
				aria-label={$format('button_close', { default: 'Close' })}
			>
				{$format('button_close', { default: 'Close' })}
			</ButtonV2>
			<ButtonV2
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap "
				responsiveSize={{ sm: 'm' }}
				on:click={openOnboarding}
				aria-label={$format('button_homes_whats_new_learn_more', {
					default: 'Learn more about Multiple Homes and Home Sharing',
				})}
			>
				{$format('link_learn_more', { default: 'Learn more' })}
			</ButtonV2>
		{:else}
			<Button
				on:click={dismissWhatsNew}
				variant="secondary"
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{ sm: 'm' }}
				aria-label={$format('button_close', { default: 'Close' })}
			>
				{$format('button_close', { default: 'Close' })}
			</Button>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				responsiveSize={{ sm: 'm' }}
				on:click={openOnboarding}
				aria-label={$format('button_homes_whats_new_learn_more', {
					default: 'Learn more about Multiple Homes and Home Sharing',
				})}
			>
				{$format('link_learn_more', { default: 'Learn more' })}
			</Button>
		{/if}
	</div>
</Modal>

<HomesOnboardingWizard
	bind:showModal={showOnboarding}
	on:complete={handleOnboardingDismiss}
	on:close={handleOnboardingDismiss}
/>
